import React, { useEffect, useState } from "react";
import { Client } from "../../interfaces/client";
import { formatDate } from "../../services/helpers";
import { HistoryAdditionalContact } from "../../interfaces/additionalContact";
import { getAdditionalContactsHistory } from "../../services/additionalContactService";

interface AdditionalContactsHistoryTableProps {
  client: Client;
}

const AdditionalContactsHistoryTable: React.FC<
  AdditionalContactsHistoryTableProps
> = ({ client }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [additionalContacts, setAdditionalContacts] = useState<
    HistoryAdditionalContact[]
  >([]);

  useEffect(() => {
    const getHistory = async () => {
      try {
        setLoadingSpinner(true);

        const historyResponse = await getAdditionalContactsHistory(
          client.clientID,
        );

        setAdditionalContacts(historyResponse);
      } catch (error) {
        console.error("Error getting additional contacts history:", error);
        setErrorMessage("Error getting additional contacts history.");
      } finally {
        setLoadingSpinner(false);
      }
    };

    getHistory();
  }, []);

  return (
    <>
      <div className="table-wrapper">
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="table-container" style={{ fontSize: "large" }}>
          <table className="table" style={{ cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "140px" }} title={"Contact Title"}>
                  Contact Title
                </th>
                <th style={{ width: "180px" }} title={"Contact First Name"}>
                  Contact First Name
                </th>
                <th style={{ width: "180px" }} title={"Contact Last Name"}>
                  Contact Last Name
                </th>
                <th style={{ width: "220px" }} title={"Contact Job Title"}>
                  Contact Job Title
                </th>
                <th style={{ width: "240px" }} title={"Contact Email"}>
                  Contact Email
                </th>
                <th style={{ width: "180px" }} title={"Email Notifications"}>
                  Email Notifications
                </th>
                <th style={{ width: "160px" }} title={"Invoice Manager"}>
                  Invoice Manager
                </th>
                <th style={{ width: "240px" }} title={"Modified By"}>
                  Modified By
                </th>
                <th style={{ width: "200px" }} title={"Modified At"}>
                  Modified At
                </th>
              </tr>
            </thead>
            <tbody>
              {additionalContacts?.length === 0 ? (
                <tr>
                  <td colSpan={9} style={{ textAlign: "center" }}>
                    No history found.
                  </td>
                </tr>
              ) : (
                additionalContacts?.map((row, index) => (
                  <tr key={`${row.additionalContactID}-${index}`}>
                    <td
                      className="ellipsis-cell"
                      title={row.contactTitle ?? ""}
                    >
                      {row.contactTitle}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.contactFirstName ?? ""}
                    >
                      {row.contactFirstName}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.contactLastName ?? ""}
                    >
                      {row.contactLastName}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.contactJobTitle ?? ""}
                    >
                      {row.contactJobTitle}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.contactEmail ?? ""}
                    >
                      {row.contactEmail}
                    </td>
                    <td>{row.emailNotifications === true ? "yes" : "no"}</td>
                    <td>{row.invoiceManager === true ? "yes" : "no"}</td>
                    <td className="ellipsis-cell" title={row.modifiedBy ?? ""}>
                      {row.modifiedBy}
                    </td>
                    <td>{formatDate(row.modifiedAt, "datetime")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {loadingSpinner && (
          <div className="loading-mask">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdditionalContactsHistoryTable;
